import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEVICE_RESOLUTION } from "../../../app-constants";

const INITIAL_STATE: {
  isMobile: boolean;
} = {
  isMobile:
    typeof window !== "undefined"
      ? window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop
      : false,
};

export const deviceSlice = createSlice({
  name: "device",
  initialState: INITIAL_STATE,
  reducers: {
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },
  },
});

export const { setIsMobile } = deviceSlice.actions;
